//React
import { FunctionComponent } from "react";

//Components
import { Result } from "../../../results/models/result";
import ResultCard from "../../../results/components/result-list/result-card";
import ResultCardQmi from "../../../results/components/result-list/result-card-qmi";

//App Hooks
import {
	useAppDispatch,
	useAppSelector,
} from "../../../system/redux/hooks/redux-store-hooks";

//Selectors
import { selectIsMobile } from "../../../system/redux/selectors/select-is-mobile";
import { setSelectedResult } from "../../../results/redux/slices/result-list-slice";
import { setIsMobileCardOpen } from "../../../system/redux/slices/app-status-slice";
import { selectIsQmiFinder } from "../../../system/redux/selectors/select-is-qmi-finder";

interface MobileInfoWindowProps {
	result: Result;
}

export const MobileInfoWindow: FunctionComponent<MobileInfoWindowProps> = (
	props,
) => {
	//Properties
	const { result } = props;

	//State Values
	const isMobile = useAppSelector(selectIsMobile);
	const isQmiFinder = useAppSelector(selectIsQmiFinder);

	//Store Dispatch
	const dispatch = useAppDispatch();

	if (result === null || !isMobile) {
		return null;
	}

	//JSX
	return (
		<div className="opened-community advanced-marker">
			<div className="opened-community-card">
				<div
					className="close-card"
					onClick={() => {
						dispatch(setIsMobileCardOpen(false));
						dispatch(setSelectedResult(null));
					}}
				></div>

				{isQmiFinder &&
					<ResultCardQmi result={result} isInInfoWindow={true} />
				}
				{!isQmiFinder &&
					<ResultCard result={result} isInInfoWindow={true} />
				}
			</div>
		</div>
	);
};

export default MobileInfoWindow;
